import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

import { checkoutStore } from "../Checkout.store";

type CheckoutToggleLine2AddressProps = ComponentProps<"button">;

export default function CheckoutToggleLine2Address({
  className,
  children,
  ...props
}: CheckoutToggleLine2AddressProps) {
  const line2Address = checkoutStore((state) => state.address.line2);
  const hasLine2Address = checkoutStore((state) => state.hasLine2Address);
  const setHasLine2Address = checkoutStore((state) => state.setHasLine2Address);

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();

    setHasLine2Address(!hasLine2Address);
  }

  // If the address has a line2 or if it's toggled open, we don't need to show the button
  if (hasLine2Address || line2Address) {
    return null;
  }

  return (
    <button
      className={cn("text-base underline", className)}
      onClick={handleClick}
      {...props}
    >
      {children}
    </button>
  );
}
